//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function deleteGroupService(id) {
    try {
        await api.delete(`/grupos-produtos/${id}`);
        toast.success("Grupo excluído com sucesso");
        return true;
    } catch (error) {
        toast.error("Erro ao excluir grupo");
        return false;
    }
}